// extracted by mini-css-extract-plugin
module.exports = {"anchor":"TopBarLinks_anchor__bZ8dw","navLink":"TopBarLinks_navLink__c_TkP"};